var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['form-item', 'form-item-textarea', {
    'valid': _vm.valid,
    'invalid' : _vm.isValidation(_vm.$props)
  }]},[(_vm.label)?_c('label',{attrs:{"for":_vm.inputID}},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('textarea',{attrs:{"id":_vm.inputID,"disabled":_vm.disabled,"name":_vm.name,"placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"input":_vm.inputHandler,"blur":function (evt){_vm.$emit('blur', evt)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }